<template>
    <Sheet v-loading="loading.actions['booking']">
        <el-divider>
            <span style="font-size:1.1rem;padding-right: 10px;">
                夜間場地借用(籃球場、排球場，採抽籤制)
                <span v-text="`- ${currentMonth.month} 月`" v-if="currentMonth"></span>
            </span>
        </el-divider>
        <div v-if="currentMonth">
            <div style="text-align: right;margin-bottom: 10px;">
                <el-button icon="el-icon-arrow-left" @click="prev" size="mini">上一步</el-button>
                <el-button
                        :icon="active === steps.length - 1 ? 'el-icon-s-promotion' : 'el-icon-arrow-right'"
                        @click="next"
                        size="mini"
                        :type="active === steps.length - 1 ? 'primary' : ''"
                >
                    {{active === steps.length - 1 ? '送出' : '下一步'}}
                </el-button>
            </div>
            <el-steps :active="active" finish-status="success" :simple="true">
                <el-step v-for="(step, idx) in steps" :title="step.title" :key="idx"></el-step>
            </el-steps>
            <el-row v-if="active === 0">
                <el-col :span="12">
                    <h2>規則說明:</h2>
                    <div v-html="(viewContent || {}).drawRule"></div>
                </el-col>
                <el-col :span="12">
                    <h2>時程</h2>
                    <el-timeline>
                        <el-timeline-item
                                :timestamp="currentMonth.publishAt"
                        >
                            登記開始日期
                        </el-timeline-item>
                        <el-timeline-item
                                :timestamp="currentMonth.dueAt"
                        >
                            登記結束日期
                        </el-timeline-item>
                        <el-timeline-item
                                :timestamp="currentMonth.drawAt"
                        >
                            抽籤日期
                        </el-timeline-item>
                    </el-timeline>

                </el-col>
            </el-row>
            <div
                    v-if="active === 1"
                    style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 400px"
            >
                <h3>請選擇場地</h3>
                <el-select v-model="roomId" size="large" @change="onRoomSelect">
                    <el-option
                            v-for="room in drawableRooms.filter(d => !d.isDrew)"
                            :key="room.id"
                            :value="room.id"
                            :label="room.name"
                    ></el-option>
                </el-select>
            </div>
            <div
                    v-if="active === 2"
                    id="drawable"
            >
                <h3>您選擇的場地: {{selectedRoom.name}}</h3>
                目前可選的時段如下，各日期請依照優先順序選擇(分兩時段:夜一18:00~20:00、夜二20:00~22:00)
                <el-row :gutter="10">
                    <el-col
                            v-for="date in availableDates"
                            :key="date"
                            :xl="8" :lg="12" :md="24" :sm="24"
                            style="margin-top: 5px; margin-bottom: 5px;"
                    >
                        <el-card>
                            <template #header>
                                {{date | fullDate}}
                            </template>
                            <el-transfer
                                    target-order="push"
                                    v-model="bookingResult[date]"
                                    :data="generateData(date)"
                                    :titles="['可選','次序']"
                            ></el-transfer>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
            <div
                    v-if="active === 3"
            >
                <h3>您選擇的場地: {{selectedRoom.name}}</h3>
                <el-form
                        ref="form"
                        :rules="rules"
                        :model="applyForm"
                        label-width="150px"

                >
                    <el-form-item label="活動名稱摘要" prop="activity">
                        <el-input
                                type="textarea"
                                v-model="applyForm.activity"
                                placeholder="請輸入活動名稱摘要(ex:休管系男排或女排(籃)練習...)"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="參加人數" prop="numberOfParticipants">
                        <el-input-number
                                :min="1"
                                :max="10000"
                                v-model="applyForm.numberOfParticipants"
                                placeholder="請輸入參加人數"
                        ></el-input-number>
                    </el-form-item>
                    <el-form-item label="參加對象" prop="participants">
                        <el-input
                                v-model="applyForm.participants"
                                type="textarea"
                                placeholder="請輸入參加對象"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="手機號碼" prop="contact">
                        <el-input
                                v-model="applyForm.contact"
                                placeholder="請輸入手機號碼(格式:09xx-xxxxxx)"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="郵件信箱" prop="email">
                        <el-input
                                v-model="applyForm.email"
                                placeholder="請輸入郵件信箱"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="單位主管或指導老師" prop="advisor">
                        <el-input
                                v-model="applyForm.advisor"
                                placeholder="請輸入單位主管或系主任、指導老師"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="器材數量">
                        <el-input
                                v-model="applyForm.equipments"
                                type="textarea"
                                placeholder="請輸入器材數量(ex:桌子X2、椅子X4)"
                        ></el-input>
                    </el-form-item>
<!--                    <el-form-item label="抽籤模式">-->
<!--                        <el-radio-group v-model="applyForm.drawMode">-->
<!--                            <el-radio :label="drawMode.Normal">一般模式</el-radio>-->
<!--                            <el-radio :label="drawMode.Continue">遞補模式</el-radio>-->
<!--                        </el-radio-group>-->
<!--                    </el-form-item>-->
                    <el-form-item label="檢附文件">
                        <small>※活動企劃書(練習及社團時間免附計畫書)或簽核文件</small>
                        <el-upload
                                ref="upload"
                                :before-upload="beforeUpload"
                                :before-remove="handleBeforeRemove"
                                :on-error="onUploadError"
                                :on-exceed="onExceedLimit"
                                :limit="fileLimit"
                                :headers="uploadHeaders"
                                :action="action"
                                :data="dataOptions"
                                :on-success="onUploadSuccess"
                        >
                            <el-button>選擇檔案</el-button>
                            <template #tip>
                                <div class="el-upload__tip">
                                    檔案不超過5MB
                                </div>
                            </template>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <el-alert
                        :closable="false"
                        type="warning"
                >
                    <small>
                        <div v-html="(viewContent ||{}).bookingWarning"></div>
                    </small>
                </el-alert>
            </div>
        </div>
        <div v-else style="text-align: center">
            <h1>抱歉，目前尚未開放登記，請參考公告時間，謝謝!!</h1>
        </div>
    </Sheet>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex';
    import moment from 'moment';
    import UploadMixin from '../../uploadMixin';

    const defaultForm = {
        activity: '',
        numberOfParticipants: 1,
        participants: '',
        equipments: '',
        advisor: '',
        certificate: undefined,
        contact: '',
        email: ''
    };

    export default {
        name: 'DrawBooking',
        data: () => ({
            active: 0,
            roomId: '',
            bookingResult: {},
            applyForm: {...defaultForm},
            rules: {
                activity: [
                    {required: true, message: '請輸入活動名稱摘要', trigger: 'blur'}
                ],
                numberOfParticipants: [
                    {required: true, message: '請輸入參加人數!', trigger: 'blur'},
                    {
                        range: {min: 1, max: 10000},
                        message: '請輸入大於0的數字!',
                        trigger: 'blur',
                        transform(value) {
                            return value.toString();
                        }
                    },
                ],
                participants: [
                    {required: true, message: '請輸入參加對象', trigger: 'blur'}
                ],
                contact: [
                    {required: true, message: '請輸入手機號碼', trigger: 'blur'},
                    {pattern: /^09\d{2}-\d{6}$/, message: '手機號碼格式請使用09xx-xxxxxx', trigger: 'blur'},
                ],
                advisor: [
                    {required: true, message: '請輸入單位主管或系主任、指導老師', trigger: 'blur'}
                ],
                email: [
                    {required: true, message: '請輸入電子郵件信箱', trigger: 'blur'},
                    {pattern: /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/
                        , message: '郵件格式錯誤', trigger: 'blur'},
                ]
            }
        }),
        mixins: [UploadMixin],
        computed: {
            ...mapState('setting', ['rooms', 'months', 'ncutRooms', 'viewContent']),
            ...mapState(['loading']),
            ...mapState('booking', ['periods', 'booked', 'availableDrawablePeriodsInRange']),
            ...mapGetters('booking', ['usedTimes']),
            currentMonth() {
                return this.months.find(m => moment(new Date()).isBetween(m.publishAt, m.dueAt));
            },
            steps() {
                const self = this;
                return [
                    {
                        required: true,
                        title: '說明',
                        validate() {
                            return self.drawableRooms.some(r => !r.isDrew);
                        },
                        message:'這個月份的已抽籤完畢，請至抽籤結果查詢當月份資訊'
                    },
                    {
                        required: true,
                        title: '選擇場地',
                        validate() {
                            return self.roomId;
                        },
                        message: '請選擇場地'
                    },
                    {
                        required: true,
                        title: '時段設定',
                        validate() {
                            return Object.keys(self.bookingResult)
                                .filter(k => self.bookingResult[k].length > 0)
                                .length > 0;
                        },
                        message: '請至少選擇一個時段'
                    },
                    {
                        required: true,
                        title: '表單填寫',
                        last: true,
                        validate() {
                            return true;
                        }
                    },
                ];
            },
            drawableRooms() {
                const drawableNcutRoomIds = new Set(this.rooms.filter(r => r.drawable)
                    .map(r => r.ncutRoomId));
                const drewRoomIds = (this.currentMonth || {}).drewRoomIds || [];

                return this.ncutRooms.filter(r => drawableNcutRoomIds.has(r.id))
                    .map(r => (
                        {
                            ...r,
                            isDrew : drewRoomIds.some(d => d === r.id )
                        }
                    ));
            },
            selectedRoom() {
                return (this.ncutRooms.find(r => r.id === this.roomId) || {name: ''});
            },
            fstDateOfNxtMonth() {
                if (this.currentMonth) {
                    return this.currentMonth.fstDate;
                }
                return '';
            },
            lstDateOfNxtMonth() {
                if (this.fstDateOfNxtMonth) {
                    return this.currentMonth.lstDate;
                }
                return '';
            },

            availableDates() {
                return [...Array(this.daysInMonth).keys()]
                    .map(d => moment(this.fstDateOfNxtMonth).add(d, 'd').format('YYYY-MM-DD'))
                    .filter(d => this.availableDrawablePeriodsInRange[d]
                        && this.availableDrawablePeriodsInRange[d].length > 0);
            },

            daysInMonth() {
                if (this.lstDateOfNxtMonth && this.fstDateOfNxtMonth) {
                    return moment(this.lstDateOfNxtMonth).diff(this.fstDateOfNxtMonth, 'd') + 1;
                }
                return 0;
            }
        },
        filters: {
            shortDate(date) {
                if (!date) return '';
                return moment(date).format('YYYY-MM-DD');
            },
            fullDate(date) {
                if (!date) return '';
                return moment(date).format('YYYY-MM-DD dddd')
            }
        },
        methods: {
            ...mapActions('booking', {
                getCourseTimes: 'getCourseTimesAction',
                getPeriods: 'getPeriodsAction',
                submitNormalForm: 'submitNormalFormAction',
                checkEvents: 'checkEventsAction',
                getAvailableDrawablePeriodsInRange: 'getAvailableDrawablePeriodsInRangeAction',
                submitDrawableForm: 'submitDrawableFormAction',
                getEventsOf: 'getBookedEventsAction'

            }),
            ...mapActions({
                removeFile: 'removeFileAction'
            }),
            ...mapActions('setting', {
                getNcutRooms: 'getNcutRoomsAction',
                getViewContent: 'getViewContentAction'
            }),

            prev() {
                this.active = Math.max(0, this.active - 1);
            },

            async submit() {
                const {form} = this.$refs;
                await form.validate(async (valid) => {
                    if (valid) {
                        try{
                            await this.$confirm('確定要送出嗎', {
                                type: 'warning',
                            });
                            const normalized = Object.keys(this.bookingResult)
                                .reduce((norm, k) => {
                                    const result = this.bookingResult[k]
                                        .map((d, idx) => {
                                            const [roomId, periodId] = d.split('_');
                                            return {roomId, periodId, order : idx + 1, date : k};
                                        });
                                    if(result.length <= 0) return norm;
                                    return [...norm, ...result];
                                }, []);
                            const {success, messages =[], status} = await this.submitDrawableForm({
                                priorities : normalized
                                , ...this.applyForm
                                , ncutRoomId: this.roomId,
                                month: this.currentMonth.month
                            });
                            if(success){
                                this.$message.success('登記成功，請等候審查!!');
                                this.reset();
                                this.$router.replace({
                                    name : 'booking/draw'
                                });
                                this.active = 0;
                                this.applyForm = {...defaultForm};
                                this.bookingResult = {};
                            } else{
                                this.$message.warning(messages.join(','));
                                this.applyForm.periodIds.splice(0);
                            }
                        }catch (e) {
                            if (e !== 'cancel') {
                                this.$message({
                                    type: 'error',
                                    message: '發生錯誤，請重試一次!'
                                });
                            }
                        }
                    }else{
                        this.$message.warning({
                            type: 'warning',
                            message: '您有欄位未輸入，請再檢查一次!!'
                        })
                    }
                });
            },

            async next() {
                const {required, validate, message, last} = this.steps[this.active];
                if (required) {
                    if (validate()) {
                        if (last) {
                            await this.submit();
                            return;
                        } else {
                            this.active = Math.min(this.steps.length, this.active + 1);
                        }
                    } else {
                        this.$message.warning(message);
                    }
                } else {
                    this.active = Math.min(this.steps.length, this.active + 1);
                }
            },
            async onRoomSelect(roomId) {
                await this.getAvailableDrawablePeriodsInRange({
                    ncutRoomId: roomId,
                    range: [this.fstDateOfNxtMonth, this.lstDateOfNxtMonth]
                });
            },
            generateData(date) {
                if (this.availableDrawablePeriodsInRange[date]) {
                    return this.availableDrawablePeriodsInRange[date]
                        .map(p =>
                            ({
                                ...p,
                                key: `${p.roomId}_${p.id}`,
                                label: `${p.tag}-${p.roomName}`
                            }));
                }
                return [];
            },

            onUploadSuccess(res) {
                this.applyForm.certificate = res;
            },

            async handleBeforeRemove(file) {
                await this.beforeRemove(file);
                this.applyForm.certificate = undefined
            },

            reset() {
                this.applyForm = {...defaultForm};
                this.$refs.upload.clearFiles();
                this.$refs.form.clearValidate();
            },
        },
        watch: {
            availableDates(dates) {
                this.bookingResult = dates.reduce((r, d) => ({...r, [d]: []}), {});
            }
        },
        async created() {
            await this.getCourseTimes();
            await this.getPeriods();
            await this.getNcutRooms();
            await this.getViewContent();
        }


    }
</script>

<style>
    #drawable .dow6, #drawable .dow0, #drawable .past, #drawable .outsideOfMonth {
        cursor: not-allowed;
        background-color: azure;
    }

    #drawable .el-transfer-panel {
        width: 200px !important;
    }

</style>
